import { ProjectContext } from "../../common/clients/ogg";
import { IProjectContextProvider } from "../../common/types";

export default class ProjectContextProviderForWebApp implements IProjectContextProvider {
    projectContextCache: ProjectContext;

    async getProjectContext(): Promise<ProjectContext> {
        return this.projectContextCache;
    }
    async setProjectContext(value: ProjectContext): Promise<void> {
        this.projectContextCache = { ...this.projectContextCache, ...value };
    }

}